// Bloquear/Desbloquear cliente. Bloquear pede o motivo: o backend grava nas Observações do
// cadastro, com quem bloqueou e quando (PATCH /customers/{id} com blockNote).
import BlockIcon from '@mui/icons-material/Block';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Button as MuiButton, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useState } from 'react';
import { Button, useDataProvider, useNotify, useRefresh } from 'react-admin';

interface Props {
  customer: any;
  showIcon?: boolean;
  sx?: object;
}

export const BlockCustomerToggle = ({ customer, showIcon, sx }: Props) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  if (!customer) { return null; }
  const blocked = customer.isBlocked;

  const save = (data: { isBlocked: boolean, blockNote?: string }) => {
    setBusy(true);
    dataProvider.update('customers', { id: customer.id, data, previousData: customer })
      .then(() => {
        notify(data.isBlocked ? 'Cliente bloqueado' : 'Cliente desbloqueado');
        setOpen(false);
        refresh();
      })
      .catch(() => notify(data.isBlocked ? 'Erro ao bloquear cliente' : 'Erro ao desbloquear cliente', { type: 'warning' }))
      .finally(() => setBusy(false));
  };

  return (
    <>
      <Button
        label={blocked ? 'Desbloquear' : 'Bloquear'}
        startIcon={showIcon ? (blocked ? <LockOpenIcon /> : <BlockIcon />) : undefined}
        disabled={busy}
        sx={sx}
        onClick={(event) => {
          // Na lista de fraudes o botão fica dentro da linha, que abre o registro ao clicar.
          event.stopPropagation();
          if (blocked) { save({ isBlocked: false }); return; }
          setNote('');
          setOpen(true);
        }}
      />
      <Dialog
        open={open}
        onClose={busy ? undefined : () => setOpen(false)}
        // Evento de dentro do portal ainda sobe pela árvore React até a linha da lista.
        onClick={(event) => event.stopPropagation()}
        sx={{ '& .MuiDialog-paper': { width: 'calc(100% - 32px)', maxWidth: 480, m: 2 } }}
      >
        <DialogTitle>Bloquear cliente</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            required
            multiline
            minRows={3}
            fullWidth
            margin="dense"
            label="Motivo do bloqueio"
            helperText="Fica salvo nas Observações do cadastro."
            value={note}
            onChange={(event) => setNote(event.target.value)}
            slotProps={{ htmlInput: { maxLength: 2000 } }}
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setOpen(false)} disabled={busy}>Cancelar</MuiButton>
          <MuiButton
            variant="contained"
            color="error"
            disabled={busy || !note.trim()}
            onClick={() => save({ isBlocked: true, blockNote: note.trim() })}
          >
            Bloquear
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
